<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Gestão de Compromissos</h1>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <list 
                    ref="vuetable" 
                    :show-empty="true" 
                    api-url="planogoverno/compromisso/pendentes-cancelamento"
                    report-title="Meus Compromissos" 
                    :fields="fields" 
                    :initial-page="1" 
                    :appendParams="filtros"
                >
                    <template slot="filters">
                        <div class="collapse" id="filtros">

                            <!-- Filtro por período -->
                            <div class="col-sm-4">
                                <label class="custom-font">Período</label>
                                <select class="form-control select-selected" v-model="filtros.periodo">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in periodos" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4"></div>

                            <!-- Filtro buttons -->
                            <div class="col-sm-4" style="padding-top: 15px;">
                                <button 
                                    @click="$refs.vuetable.refresh()" 
                                    class="btn btn-default margem-topo"
                                    name="btnFiltrar"
                                >
                                    <font-awesome-icon :icon="'filter'" />
                                    Filtrar
                                </button>
                                <button 
                                    @click="resetFiltros()" 
                                    class="btn btn-default margem-topo" 
                                    name="btnLimpar"
                                >
                                    <font-awesome-icon :icon="'eraser'" />
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </template>

                    <template slot="actions">
                        <button 
                            class="btn btn-default" 
                            data-toggle="collapse" 
                            data-target="#filtros"
                        >
                            <font-awesome-icon :icon="'filter'" /> Filtros
                        </button>
                    </template>

                    <template slot="rowrender" slot-scope="props">
                        <div>
                            <button 
                                title="Aceitar"
                                type="button"
                                class="btn btn-primary"
                                @click="cancelar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'edit'" />
                            </button>
                        </div>
                    </template>
                </list>
            </div>

            <SidePlanoGoverno 
                ref="side" 
                :navs="sideConfig" 
                @aceitarRequisicao="aceitarRequisicao"
                @rejeitarRequisicao="rejeitarRequisicao"  
            />
        </div>
    </div>
</template>

<script>
import list from '@/components/common/DataTable'
import SidePlanoGoverno from '@/components/planogoverno/SidePlanoGoverno.vue'
import { request } from '@/request'

export default {
    components: { list, SidePlanoGoverno },
    data() {
        return {
            fields: [
            {
                    name: 'periodo',
                    title: 'Período',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: 'descritivo',
                    title: 'Compromisso',
                    filterable: true
                },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-3',
                    dataClass: 'text-center'
                }
            ],
            filtros: {
                periodo: '',
            },
            periodos: [
                '2021-2024',
                '2025-2028'
            ],
            sideConfig: [
                {
                    titulo: 'Cancelar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'cancelar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
            ],
        }
    },
    methods: {
        cancelar(compromisso) {
            this.sideConfig[0].data = compromisso;
            this.sideConfig[0].subtitulo = compromisso.descritivo;
            
            this.$refs.side.$emit('abreModal', this.sideConfig[0].identidade);
        },
        async cancelarAcoes(compromisso) {
            const acoes = compromisso.acoes || [];

            if (acoes && Array.isArray(acoes)) {
                acoes.forEach(async (acao) => {
                    if (acao.status !== 'Cancelado' || acao.status !== 'Rejeitada') {
                        try {
                            await request.put(
                                `planogoverno/compromisso-acao/${acao.id}`,
                                {
                                    justificativa_rejeicao: 'Compromisso cancelado',
                                    status: 'Cancelada'
                                }
                            );
                        } catch (err) {
                            console.error(`Erro ao cancelar a ação com ID ${acao.id}:`, err);
                        }
                    }
                })
            }
        },
        async aceitarRequisicao(compromisso) {
            try {
                await this.cancelarAcoes(compromisso);

                const { status } = await request.put(
                    `planogoverno/compromisso/${compromisso.id}`,
                    { status: 'Cancelado' }
                )

                if (status !== 200) return this.$toastr.e('Erro ao cancelar o compromisso.')

                this.$refs.vuetable.refresh()
                this.$toastr.s('Compromisso cancelado com sucesso.')
                this.$refs.side.$emit('fechaModal', this.sideConfig[0].identidade)
            } catch (err) {
                console.error('Erro ao aceitar a requisição de cancelamento:', err)
                this.$toastr.e('Ocorreu um erro no processo de cancelamento.')
            }
        },
        async rejeitarRequisicao(compromissoId) {
            try {
                const { status } = await request.put(
                    `planogoverno/compromisso/${compromissoId}`,
                    { justificativa_cancelamento: null }
                )

                if (status !== 200) return this.$toastr.e('Erro ao rejeitar a solicitação.')

                this.$refs.vuetable.refresh()
                this.$toastr.s('Solicitação de cancelamento rejeitada com sucesso.')
                this.$refs.side.$emit('fechaModal', this.sideConfig[0].identidade)
            } catch (err) {
                console.error('Erro ao rejeitar o cancelamento:', err)
                this.$toastr.e('Erro ao rejeitar a solicitação.')
            }
        },
        resetFiltros() {
            this.filtros.periodo = ''
            this.filtros.status = ''
        }
    }
}
</script>

<style scoped>
.custom-font {
    font-size: 16px;
    color: #00615c;
}

.icon {
    min-width: 14px;
}

.button {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.button-danger {
    background-color: #dc3545;
    border-color: #dc3545;
    color: #fff;
    text-transform: uppercase;
}

.button-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
    color: #fff;
}

.button-success {
    background-color: #28a745;
    border-color: #28a745;
    color: #fff;
    text-transform: uppercase;
}

.button-success:hover {
    background-color: #218838;
    border-color: #1e7e34;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/GestaoCompromissos.vue